import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Grid, Modal, Heading, Form, Button, Input, Textblock, Panel } from 'framework-ui-components';
import { erratiCodiciFiscaliDichiarazione } from 'apis/setteTrentaApi';
import { EsitoControlloSiatel } from 'enums';

const Vocale = carattere => {
    if (carattere == 'A' || carattere == 'E' || carattere == 'I' || carattere == 'O' || carattere == 'U') {
        return true;
    }

    return false;
};

const codiceFiscaleValido = value => {

    // se vuota i dati sono validi
    if (value === null || value === undefined) {
        return true;
    }

    // se non � una stringa non � un codice fiscale valido
    if (typeof (value) != "string") {
        return false;
    }

    let cf = value;
    let validi, i, s, set1, set2, setpari, setdisp;

    if (cf == '') {
        return true;
    }

    cf = cf.toUpperCase();

    if (cf.length != 16) {
        return false;
    }

    validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for (let i = 0; i < 16; i++) {
        if (validi.indexOf(cf.charAt(i)) == -1) {
            return false;
        }
    }

    set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";

    s = 0;
    for (let i = 1; i <= 13; i += 2) {
        s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }

    for (let i = 0; i <= 14; i += 2) {
        s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }

    if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
        return false;
    }

    return true;
};


const nomeCompatibileCodiceFiscale = (nome, cf) => {
    if (nome == "") {
        return true;
    }

    if (cf == "" || cf == null) {
        return true;
    }

    if (!codiceFiscaleValido(cf)) {
        return true;
    }

    var nomeAux = nome.replace(/[^a-zA-Z]+/gi, '');

    var nomeCondensato = "";
    for (const car of nomeAux) {
        if (!Vocale(car.toUpperCase())) {
            nomeCondensato += car;
        }
    }

    if (nomeCondensato.length > 3) {
        nomeCondensato = nomeCondensato[0] + nomeCondensato.substring(2);
    }

    if (nomeCondensato.length < 3) {
        for (const car of nome) {
            if (Vocale(car.toUpperCase())) {
                nomeCondensato += car;
            }
        }
    }

    if (nomeCondensato.length < 3) {
        for (var i = 0; i < (3 - nomeCondensato.length); i++) {
            nomeCondensato += "X";
        }
    }

    // verifico la coerenza
    if (nomeCondensato.length >= 3 && nomeCondensato.substring(0, 3).toLowerCase() == cf.substring(3, 6).toLowerCase()) {
        return true;
    }

    return false;
};

const cognomeCompatibileCodiceFiscale = (nome, cf) => {
    if (nome == "") {
        return true;
    }

    if (cf == "" || cf == null) {
        return true;
    }

    if (!codiceFiscaleValido(cf)) {
        return true;
    }

    var nomeAux = nome.replace(/[^a-zA-Z]+/gi, '');

    var nomeCondensato = "";
    for (const car of nomeAux) {
        if (!Vocale(car.toUpperCase())) {
            nomeCondensato += car;
        }
    }

    if (nomeCondensato.length < 3) {
        for (const car of nome) {
            if (Vocale(car.toUpperCase())) {
                nomeCondensato += car;
            }
        }
    }

    if (nomeCondensato.length < 3) {
        for (var i = 0; i < (3 - nomeCondensato.Length); i++) {
            nomeCondensato += "X";
        }
    }

    // verifico la coerenza
    if (nomeCondensato.length >= 3 && nomeCondensato.substring(0, 3).toLowerCase() == cf.substring(0, 3).toLowerCase()) {
        return true;
    }

    return false;
};

const _initialData = {
    IdAnagraficaDichiarante: null,
    IdAnagraficaConiuge: null,
    CodiceFiscaleDichiarante: null,
    CognomeDichiarante: null,
    NomeDichiarante: null,
    CodiceFiscaleConiuge: null,
    DenominazioneConiuge: null,
    dichiaranteErrato: false,
    coniugeErrato: false,
    altriErrati: false,
    codiciFiscaliDichiarazione: [],
    loading: false
};

class ModaleCodiceFiscale extends Component {
    state = {
        ..._initialData
    }

    componentWillReceiveProps({ show, data, idDichiarazione, idDichiarazioneConiuge }) {
        if (show != this.props.show && show) {
            this.setState(data);
            this.caricaCodiciFiscali(idDichiarazione, idDichiarazioneConiuge);
        }
    }

    caricaCodiciFiscali = (idDichiarazione, idDichiarazioneConiuge) => {
        this.setState({ loading: true }, () => {
            erratiCodiciFiscaliDichiarazione(idDichiarazione, idDichiarazioneConiuge, this.props.annoSelezionato)
                .then(res => {
                    let dichiaranteErrato = res.find(x => x.CodiceFiscale == this.state.CodiceFiscaleDichiarante &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    let coniugeErrato = res.find(x => x.CodiceFiscale == this.state.CodiceFiscaleConiuge &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    let altriErrati = res.filter(x => x.CodiceFiscale != this.state.CodiceFiscaleDichiarante && x.CodiceFiscale != this.state.CodiceFiscaleConiuge &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    this.setState({
                        codiciFiscaliDichiarazione: res,
                        dichiaranteErrato: dichiaranteErrato,
                        coniugeErrato: coniugeErrato,
                        altriErrati: altriErrati,
                        NuovoCodiceFiscaleConiuge: coniugeErrato ? coniugeErrato.NuovoCodiceFiscale : '',
                        NuovoCodiceFiscaleDichiarante: dichiaranteErrato ? dichiaranteErrato.NuovoCodiceFiscale : '',
                        loading: false
                    });
                });
        });
    }

    changeForm = data => {
        this.setState(data);
    }

    annulla = () => {
        const { onClose } = this.props;
        this.setState(_initialData, () => {
            onClose && onClose();
        });
    }

    modifica = () => {
        const { onModifica } = this.props;
        if (this.refForm.valida()) {
            onModifica && onModifica(this.state);
        }
    }

    inLavorazione = () => {
        const { inLavorazione, onClose } = this.props;
        inLavorazione && inLavorazione(this.state);
        onClose && onClose();
    }

    render() {
        const { errore, isLoading, show } = this.props;
        const { CodiceFiscaleDichiarante, CognomeDichiarante, NomeDichiarante, CodiceFiscaleConiuge, DenominazioneConiuge,
            dichiaranteErrato, coniugeErrato, altriErrati, loading } = this.state;

        return (
            <Modal loading={isLoading || loading} onClose={this.annulla} show={show}>
                <Modal.Header>
                    Correggi codici fiscali
                </Modal.Header>
                <Modal.Body>
                    <Form stato={this.state} onChange={this.changeForm} ref={r => this.refForm = r}>
                        <Grid fluid>
                            <Grid.Row>
                                <Heading as="label" className="label--title">Dichiarante{dichiaranteErrato && <span>: {dichiaranteErrato.DescrizioneStato}</span>}</Heading>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Col md="4">
                                    <Textblock label="Codice fiscale attuale" text={CodiceFiscaleDichiarante} />
                                </Grid.Col>
                                <Grid.Col md="4">
                                    <Textblock label="Cognome attuale" text={CognomeDichiarante} />
                                </Grid.Col>
                                <Grid.Col md="4">
                                    <Textblock label="Nome attuale" text={NomeDichiarante} />
                                </Grid.Col>
                            </Grid.Row>

                            {dichiaranteErrato &&
                                <Grid.Row>
                                    <Grid.Col md="4">
                                        <Input name="NuovoCodiceFiscaleDichiarante" title="Codice fiscale" validations={["required", "CodiceFiscaleAlfaNumerico", (x) => x.toLowerCase() == this.state.CodiceFiscaleDichiarante.toLowerCase() ? "I codici fiscali devono essere diversi" : null]} disabled={!dichiaranteErrato} />
                                    </Grid.Col>
                                    <Grid.Col md="4">
                                        <Input name="NuovoCognomeDichiarante" title="Cognome" validations={["required", (x) => cognomeCompatibileCodiceFiscale(x, this.state.NuovoCodiceFiscaleDichiarante) ? null : "Cognome non compatibile con il codice fiscale"]} disabled={!dichiaranteErrato} />
                                    </Grid.Col>
                                    <Grid.Col md="4">
                                        <Input name="NuovoNomeDichiarante" title="Nome" validations={["required", (x) => nomeCompatibileCodiceFiscale(x, this.state.NuovoCodiceFiscaleDichiarante) ? null : "Nome non compatibile con il codice fiscale"]} disabled={!dichiaranteErrato} />
                                    </Grid.Col>
                                </Grid.Row>
                            }

                            {CodiceFiscaleConiuge &&
                                <Fragment>
                                    <Grid.Row>
                                        <Heading as="label" className="label--title">Coniuge{coniugeErrato && <span>: {coniugeErrato.DescrizioneStato}</span>}</Heading>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Col md="4">
                                            <Textblock label="Codice fiscale attuale" text={CodiceFiscaleConiuge} />
                                        </Grid.Col>
                                        <Grid.Col md="8">
                                            <Textblock label="Denominazione attuale" text={DenominazioneConiuge} />
                                        </Grid.Col>
                                    </Grid.Row>

                                    {coniugeErrato &&
                                        <Grid.Row>
                                            <Grid.Col md="4">
                                                <Input name="NuovoCodiceFiscaleConiuge" title="Codice fiscale" validations={["required", "CodiceFiscaleAlfaNumerico", (x) => x.toLowerCase() == this.state.CodiceFiscaleConiuge.toLowerCase() ? "I codici fiscali devono essere diversi" : null]} disabled={!coniugeErrato} />
                                            </Grid.Col>
                                            <Grid.Col md="4">
                                                <Input name="NuovoCognomeConiuge" title="Cognome" validations={["required", (x) => cognomeCompatibileCodiceFiscale(x, this.state.NuovoCodiceFiscaleConiuge) ? null : "Cognome non compatibile con il codice fiscale"]} disabled={!coniugeErrato} />
                                            </Grid.Col>
                                            <Grid.Col md="4">
                                                <Input name="NuovoNomeConiuge" title="Nome" validations={["required", (x) => nomeCompatibileCodiceFiscale(x, this.state.NuovoCodiceFiscaleConiuge) ? null : "Nome non compatibile con il codice fiscale"]} disabled={!coniugeErrato} />
                                            </Grid.Col>
                                        </Grid.Row>
                                    }
                                </Fragment>
                            }

                            {altriErrati && altriErrati.length > 0 &&
                                <Fragment>
                                    <Grid.Row>
                                        <Heading as="label" className="label--title pb-8">Altri soggetti</Heading>
                                    </Grid.Row>
                                    {altriErrati.map((x, i) =>
                                        (<Grid.Row key={i}>
                                            <Grid.Col md="12">{x.CodiceFiscale}: {x.DescrizioneStato} {x.NuovoCodiceFiscale && <span>({x.NuovoCodiceFiscale})</span>}</Grid.Col>
                                        </Grid.Row>)
                                    )}
                                </Fragment>
                            }
                        </Grid>
                    </Form>
                    {errore &&
                        <Panel alert>{errore}</Panel>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button flat onClick={this.annulla}>Annulla</Button>
                    {(coniugeErrato || dichiaranteErrato) &&
                        <Button flat primary onClick={this.modifica}>Modifica</Button>
                    }
                    {(!coniugeErrato && !dichiaranteErrato) &&
                        <Button flat primary onClick={this.inLavorazione}>Porta in Lavorazione</Button>
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

ModaleCodiceFiscale.propTypes = {
    errore: PropTypes.string,
    idDichiarazione: PropTypes.string.isRequired,
    idDichiarazioneConiuge: PropTypes.string,
    isLoading: PropTypes.bool,
    onClose: PropTypes.func,
    onModifica: PropTypes.func,
    show: PropTypes.bool,
    annoSelezionato: PropTypes.number
};

export default ModaleCodiceFiscale;